import React, { Component } from "react";
import {
  Button,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import { inject, observer } from "mobx-react";
import DataWrapper from "../../principal/containers/DataWrapper";
import ModalForm from "../../comum/components/ModalForm";
import ModalAviso from "../../comum/components/ModalAviso";
import CargaGeralAcompanhamentoStore from "../stores/CargaGeralAcompanhamentoStore";
import Footer from "../../comum/components/Footer";
import FooterContent from "../../comum/components/FooterContent";
import FooterOptions from "../../comum/components/FooterOptions";
import IconButton from "../../comum/components/IconButton";
import { makePDF } from "../../../utils/formatar";
import _ from "lodash";
import FiltrosCargaGeralAcompanhamento from "../components/FiltrosCargaGeralAcompanhamento";
import { TabelaCargaGeralAcompanhamento } from "../components/TabelaCargaGeralAcompanhamento";
import ExportarExcelCargaGeralAcompanhamento from "../components/ExportarExcelCargaGeralAcompanhamento";
import AgendamentoCargaGeralService from "../../../services/AgendamentoCargaGeralService";
import { IconeCarregar } from "../../comum/components/Icones";
import ModalAvisoCargaGeral from "../../comum/components/ModalAvisoCargaGeral";
import lscache from "lscache";

@inject("store")
@DataWrapper
@observer
export class CargaGeralAcompanhamento extends Component {
  constructor(props) {
    super(props);
    this.tituloPaginaStore = this.props.store.tituloPaginaStore;

    this.service = new AgendamentoCargaGeralService();
    this.controller = new CargaGeralAcompanhamentoStore(this.service);
  }

  componentDidMount() {
    this.tituloPaginaStore.setTitulo("Carga Geral");
    this.controller.carregarDadosNavio();
    let voltarParam = _.get(this.props.location.state, `voltar`);
    this.props.store.appStore.showVoltarTopBar(
      voltarParam ? true : false,
      voltarParam ? voltarParam : "/"
    );
  }

  componentDidUpdate() {
    this.aviso();
  }

  aviso = () => {
    if (this.controller.listaMensagens)
      return (
        <ModalAvisoCargaGeral
          onClickFechar={() => (this.controller.listaMensagens = false)}
        >
          {this.controller.listaMensagens.map((msg, x) => (
            <h2 key={x}>{msg}</h2>
          ))}
        </ModalAvisoCargaGeral>
      );
  };

  render() {
    const somaPesoLiquidoSelecionados = this.controller.selecionados.reduce(
      (acc, selecionado) => {
        return acc + (selecionado.PesoLiquido || 0); // assegura que pesoLiquido é um número e soma
      },
      0
    );

    const somaPesoLiquidoInicial = this.controller.itens.reduce(
      (acc, inicial) => {
        return acc + (inicial.PesoLiquido || 0); // assegura que pesoLiquido é um número e soma
      },
      0
    );

    const msgSelecionadas =
      this.controller.selecionados.length === 1 ? "Placa" : "Placas";
    const msgInicial = this.controller.itens.length === 1 ? "Placa" : "Placas";

    let pdfData;

    if (lscache.get("Perfil").includes("TRANSPORTADOR CARGA GERAL")) {
      pdfData = this.controller.colunasExportacaoTransportadora;
    } else {
      pdfData = this.controller.colunasExportacao;
    }

    return (
      <div className="form-wrapper">
        {this.aviso()}

        {
          <Container
            className="liberacao-cabotagem tela-botoes-inclusao-topo"
            fluid
          >
            <FiltrosCargaGeralAcompanhamento controller={this.controller} />

            <TabelaCargaGeralAcompanhamento controller={this.controller} />
          </Container>
        }
        <Footer>
          <FooterContent>
            <div className="justify-content-between">
              {this.controller.selecionados.length > 0 ? (
                <div>
                  <b>
                    {this.controller.selecionados.length}/
                    {this.controller.itens.length} {msgInicial}
                  </b>{" "}
                  || Peso total: {somaPesoLiquidoSelecionados} Kg
                </div>
              ) : (
                <div>
                  <b>{this.controller.itens.length}</b> {msgSelecionadas} ||
                  Peso total: {somaPesoLiquidoInicial} Kg
                </div>
              )}
            </div>
          </FooterContent>
          <FooterOptions>
            <div>
              {this.controller.selecionados.length > 0 ? (
                <IconButton
                  icon="file-pdf"
                  text="Baixar PDF"
                  size="md"
                  disabled={this.controller.cargasLista.length === 0}
                  onClick={() =>
                    makePDF(
                      this.controller.selecionados,
                      pdfData.map((elem) => elem.dataField),
                      pdfData.map((elem) => elem.text),
                      [],
                      true,
                      false,
                      { qtdColFixo: "A2", nomeDoArquivo: "CargasGerais.pdf" }
                    )
                  }
                />
              ) : (
                <IconButton
                  icon="file-pdf"
                  text="Baixar PDF"
                  size="md"
                  disabled={this.controller.cargasLista.length === 0}
                  onClick={() =>
                    makePDF(
                      this.controller.cargasLista,
                      pdfData.map((elem) => elem.dataField),
                      pdfData.map((elem) => elem.text),
                      [],
                      true,
                      false,
                      { qtdColFixo: "A2", nomeDoArquivo: "CargasGerais.pdf" }
                    )
                  }
                />
              )}
            </div>
            <div>
              <ExportarExcelCargaGeralAcompanhamento
                controller={this.controller}
              />
            </div>
          </FooterOptions>
          <FooterContent className="right-pos">
            <div>
              {!this.controller.salvando ? (
                <Button
                  className="btn-primary"
                  onClick={() => this.controller.reListar()}
                >
                  ATUALIZAR
                </Button>
              ) : (
                <IconeCarregar tamanho="2x" cor="#001C43" />
              )}
            </div>
          </FooterContent>
        </Footer>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/carga-geral/telas/CargaGeralAcompanhamento.js